import { atom } from 'recoil';

// All v1 retainers
export const allRetainers = atom({
  key: 'allRetainers',
  default: null
});

export const retainerDetails = atom({
  key: 'retainerDetails',
  default: {}
});

export const showRetainerInfoPoster = atom({
  key: 'showRetainerInfoPoster',
  default: false
});
